var $871bbfc4aa8f48bc$exports = {};
$871bbfc4aa8f48bc$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}iri za detalje`
};


export {$871bbfc4aa8f48bc$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
